import { z } from 'zod';

import { analysisDetailSearchSchema } from '@/modules/lab-shared/lib/list-search';

export const germinationDetailSearchSchema = analysisDetailSearchSchema.extend({
  setup: z.boolean().optional().catch(undefined),
});
